'use strict';

angular.module('msCommunity').controller('CommunityDiscussionDetailCtrl', ['$stateParams', 'discussionSvc', 'discussion', 'activity', 'NotifyingSvc', function ($stateParams, discussionSvc, discussion, activity, NotifyingSvc) {
  var vm = this;
  vm.replyId = $stateParams.replyId;
  vm.discussion = discussion;
  vm.activity = activity;
  vm.newDiscussion = {
    content: '',
    topic: discussion.topic,
    activityId: discussion.activityId,
    parentId: discussion.id
  };

  NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
    pageTitle: 'Discussing "' + activity.title + '"'
  });

  vm.post = function (discussion) {
    discussion.activityId = vm.activity.id;
    if (!discussion.content) {
      return;
    }
    discussionSvc.post(discussion).then(function (resp) {
      vm.discussion.comments.push(resp);
      discussion.content = '';
    });
  };

  vm.removeComment = function (commentId) {
    vm.discussion.comments.forEach(function (comment) {
      if (commentId === comment.id) {
        comment.flag = 'ANYTHING_BUT_FAVORITE';
      }
    });
  };
}]);